import React, { useState, useEffect, useContext } from "react";
import Button from "../components/buttons/Button";
import { ModalContext } from "../context/contextProvider";
import ListGroup from 'react-bootstrap/ListGroup';

//https://blog.logrocket.com/creating-react-context-menu/
const MenuContextHook = ({ data, visible, x, y }) => {
  const { showContextMenu } = useContext(ModalContext);


  useEffect(() => {
    if (visible) {
      const handleClick = () => {
        showContextMenu(null, false, 0, 0);
        //setVisible(false);
      }
      document.addEventListener("click", handleClick);
      return () => {
        document.removeEventListener("click", handleClick);
      };
    }
  }, [visible]);


  if (data)
    return (
      visible && (
        <ListGroup style={{
          position: 'absolute',
          width: '200px',
          backgroundColor: '#383838',
          borderRadius: '5px',
          boxSizing: 'border-box',
          top: `${y}px`,
          left: `${x}px`,
          /* hover */
          liHover: {
            cursor: 'pointer',
            backgroundColor: '#000000',
          },
        }}>
          {data.map((item) => {
            return (
              <ListGroup.Item key={item?.id} action onClick={item?.onClick}>
                {item?.title}
              </ListGroup.Item>
            );
          })}
        </ListGroup >
      )
    );
};
export default MenuContextHook;
